// extracted by mini-css-extract-plugin
export default {"_":"loader____6gKlg","loader-1":"loader_loader-1__9k8gw","loader-2":"loader_loader-2__9G6Iv","loader-3":"loader_loader-3__GFo4D"};